module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/ノートパソコンデュアルカメラ.be10e287.png";